const STORAGE_KEY = 'cigartrack_help_bookmarks'
const LEGACY_STORAGE_KEY = 'cigartrack_bookmarks'

export function loadHelpBookmarks(knownSlugs: Set<string>): string[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored) as string[]
      if (Array.isArray(parsed)) {
        return parsed.filter((s) => typeof s === 'string' && knownSlugs.has(s))
      }
    }
  } catch {
    // ignore
  }

  try {
    const legacy = localStorage.getItem(LEGACY_STORAGE_KEY)
    if (legacy) {
      const parsed = JSON.parse(legacy) as string[]
      if (Array.isArray(parsed)) {
        const migrated = parsed.filter((id) => typeof id === 'string' && knownSlugs.has(id))
        if (migrated.length > 0) {
          saveHelpBookmarks(migrated)
        }
        return migrated
      }
    }
  } catch {
    // ignore
  }

  return []
}

export function saveHelpBookmarks(slugs: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs))
  } catch {
    // ignore storage errors
  }
}
